import { Component, OnInit } from '@angular/core';
import { NavigationCancel, NavigationError, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {
    // No global Router error visibility existed before this: a guard/interceptor
    // exception or an overlapping navigation would fail the Router silently,
    // leaving sidebar clicks doing nothing until a full page reload. Logging
    // here won't fix a stuck Router by itself, but it turns the next occurrence
    // from "nothing happened" into a diagnosable error in the console.
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationError) {
        console.error('[Router] NavigationError', {
          url: event.url,
          error: event.error,
        });
      } else if (event instanceof NavigationCancel) {
        console.warn('[Router] NavigationCancel', {
          url: event.url,
          reason: event.reason,
          code: event.code,
        });
      }
    });
  }
}
